var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

const bundle_metadata = {
  items: {},
};

function getBundleItemQuantity(id) {
  return (
    (bundle_metadata.items[id] = bundle_metadata.items[id] || {
      quantity: 0,
    }),
    bundle_metadata.items[id].quantity
  );
}
function saveToBundleMetadata(id, quantity = 1) {
  (bundle_metadata.items[id] = bundle_metadata.items[id] || {
    quantity: 0,
  }),
    (bundle_metadata.items[id].quantity += quantity);
  let totalItemsInBundle = 0;
  Object.keys(bundle_metadata.items).forEach(function (variant_id) {
    bundle_metadata.items[variant_id].quantity > 0
      ? ($('.bb-free-bag-item[data-variant-id="' + variant_id + '"]').addClass(
          "bb-added-to-bundle"
        ),
        $(
          '.bb-free-bag-item[data-variant-id="' +
            variant_id +
            '"] .bb-quantity input'
        ).val(bundle_metadata.items[variant_id].quantity))
      : ($(
          '.bb-free-bag-item[data-variant-id="' + variant_id + '"]'
        ).removeClass("bb-added-to-bundle"),
        $(
          '.bb-free-bag-item[data-variant-id="' +
            variant_id +
            '"] .bb-quantity input'
        ).val(1));
    const maxQuantity = parseInt(
      $('.bb-free-bag-item[data-variant-id="' + variant_id + '"]').data("max")
    );
    maxQuantity > 0 &&
      (bundle_metadata.items[variant_id].quantity >= maxQuantity
        ? $(
            '.bb-free-bag-item[data-variant-id="' +
              variant_id +
              '"] .bb-add-product-bundle'
          )
            .addClass("disabled")
            .attr("disabled", !0)
        : $(
            '.bb-free-bag-item[data-variant-id="' +
              variant_id +
              '"] .bb-add-product-bundle'
          )
            .removeClass("disabled")
            .removeAttr("disabled")),
      (totalItemsInBundle += bundle_metadata.items[variant_id].quantity);
  }),
    console.log(bundle_metadata),
    totalItemsInBundle >= 5
      ? $(".bb-add-product-bundle")
          .addClass("disabled")
          .attr("disabled", "disabled")
      : $(".bb-add-product-bundle")
          .removeClass("disabled")
          .removeAttr("disabled");
}
function updateBundlePrice() {
  let $quantity = $(".bb-item-active").length;
  let totalPrice = 0;

  // Calculate base total price
  $(".bb-item-active").each(function () {
    const variantId = $(this).data("variant-id");
    const itemPrice = $(
      '.bb-free-bag-item[data-variant-id="' + variantId + '"]'
    ).data("price");
    totalPrice += itemPrice;
  });

  let priceChange = 1;
  let subscriptionPriceChange = 1;

  // Update item count
  $(".added-items-heading .add-item_count").text($quantity);

  
  $(".recharge-subscriptions-new-style").toggleClass(
    "show-recharge-subscriptions-new-style",
    $quantity >= 1
  );
  $(".free-shipping-progress-bar").toggleClass(
    "only-one-product-added",
    $quantity == 1
  );
  $(".free-shipping-progress-bar").toggleClass(
    "five-products-added",
    $quantity == 5
  );

  // Set free shipping and progress text based on quantity
  const progressTextMap = {
    0: "You’re 2 products away from 10% off",
    1: "Add 1 more product for 10% off",
    2: "Add 1 more for 20% off + Free Shipping!",
    3: "Add 2 more products for 24% off",
    4: "Add 1 more product for 24% off",
    5: "24% off unlocked!",
  };

  $(".free-shipping-bar-text").text(
    progressTextMap[$quantity] || progressTextMap[0]
  );

  // Progress bars and savings info
  $(".left-side-progress-bar1").toggleClass(
    "active-progress-bar",
    $quantity >= 1
  );
  $(".left-side-progress-bar2").toggleClass(
    "active-progress-bar",
    $quantity >= 2
  );
  $(".middle-side-progress-bar").toggleClass(
    "active-progress-bar",
    $quantity >= 3
  );
  $(".right-side-progress-bar1").toggleClass(
    "active-progress-bar",
    $quantity >= 4
  );
  $(".right-side-progress-bar2").toggleClass(
    "active-progress-bar",
    $quantity >= 5
  );

  $(".free-shipping-bar-text-info .free-shipping-text").toggleClass(
    "active-progress-area",
    $quantity >= 2
  );
  $(".save-percentage-text.save-percentage-text1").toggleClass(
    "active-progress-area",
    $quantity >= 3
  );
  $(".save-percentage-text.save-percentage-text2").toggleClass(
    "active-progress-area",
    $quantity >= 5
  );

  // Determine discount based on quantity
   if ($quantity >= 2) priceChange = 0.90;
  if ($quantity >= 3) priceChange = 0.80;
  if ($quantity >= 5) priceChange = 0.76;

  // Check subscription plan
  const selectedInput = document.querySelector(
    'input[name="prductType"]:checked'
  );
  if (selectedInput && selectedInput.value === "2") {
    subscriptionPriceChange = 0.85;
  }

  const originalPrice = totalPrice;
  const discountedPrice = priceChange * totalPrice * subscriptionPriceChange;

  
  // Toggle pricing class and subscription box
  $(".bb-added-items-total").toggleClass(
  "one-time-purchase-price",
  originalPrice > discountedPrice
  );

  

  const originalPriceFormatted = Shopify.formatMoney(
    (Math.round(originalPrice) / 100).toFixed(2),
    window.theme.moneyFormat
  );
  const newPriceFormatted = Shopify.formatMoney(
    (Math.round(discountedPrice) / 100).toFixed(2),
    window.theme.moneyFormat
  );

  $(".bb-original-price").html(originalPriceFormatted).show();
  $(".sub-total-price").html(newPriceFormatted).show();

  if (originalPrice === 0) {
    $(".bb-savings").addClass("hide-savings");
    $(".bb-original-price").hide();
  } else {
    if (originalPrice > discountedPrice) {
      const savings = originalPrice - discountedPrice;
      const savingsFormatted = Shopify.formatMoney(
        (Math.round(savings) / 100).toFixed(2),
        window.theme.moneyFormat
      );
      // $(".bb-savings").html(savingsFormatted).removeClass("hide-savings");
    } else {
      // $(".bb-savings").addClass("hide-savings");
      $(".sub-total-price").hide();
    }
  }

  $(".bb-added-items-total p span:not(.bb-original-price)").html(
    newPriceFormatted
  );
  $(".bb-added-items-total").data("price", discountedPrice);
  $(".original-total-price").html(originalPriceFormatted);
  $(".shipping-price-element").toggle(discountedPrice >= 9900);

  console.log("Selected value:", selectedInput?.value);
  console.log("Original:", originalPrice, "| Discounted:", discountedPrice);
}
function initializeProductPopupsAndAccordion() {
  document.querySelectorAll(".view-detail-btn").forEach(function (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      var parentElement = button.closest(".ProductItem__Info-Wrapper");
      var popup = parentElement.querySelector(".popup");
      if (popup) {
        popup.style.display = "block";
        document.body.classList.add("locked-body");
      }
    });
  });

  // Handle popup close
  document.querySelectorAll(".popup .close, .popup-overlay").forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      var popup = this.closest(".popup");
      if (popup) {
        popup.style.display = "none";
        document.body.classList.remove("locked-body");
      }
    });
  });
  
  document.addEventListener('click', function(e) {
  if (e.target.closest('.popup-content')) {
    e.preventDefault();
    e.stopPropagation();
  }
});


  // $('body').on('click', function(e){
  //   e.preventDefault();
  //   $('.popup').hide();
  // });

  // Handle accordion behavior
  // var acc = document.getElementsByClassName("dynamic-metafield-accordion");
  // for (var i = 0; i < acc.length; i++) {
  //   acc[i].addEventListener("click", function () {
  //     this.classList.toggle("metafield-accordion-custom-active");
  //     var panel = this.nextElementSibling;
  //     if (panel) {
  //       panel.classList.toggle("active-content");
  //       if (panel.style.maxHeight) {
  //         panel.style.maxHeight = null;
  //       } else {
  //         panel.style.maxHeight = panel.scrollHeight + "px";
  //       }
  //     }
  //   });
  // }

  var acc = document.getElementsByClassName("dynamic-metafield-accordion");
  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      // First, close all panels
      for (var j = 0; j < acc.length; j++) {
        if (acc[j] !== this) {
          acc[j].classList.remove("metafield-accordion-custom-active");
          var otherPanel = acc[j].nextElementSibling;
          if (otherPanel) {
            otherPanel.classList.remove("active-content");
            otherPanel.style.maxHeight = null;
          }
        }
      }
  
      // Then, toggle the clicked one
      this.classList.toggle("metafield-accordion-custom-active");
      var panel = this.nextElementSibling;
      if (panel.classList.contains("active-content")) {
        panel.classList.remove("active-content");
        panel.style.maxHeight = null;
      } else {
        panel.classList.add("active-content");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
}
function initSubscriptionToggle() {
  const labels = document.querySelectorAll(".rc-label");
  labels.forEach(function (label) {
    label.addEventListener("click", function () {
      setTimeout(() => {
        let bbTotal = document.querySelector(".bb-added-items-total");
        if (!bbTotal) {
          console.log("Element .bb-added-items-total not found");
          return;
        }

        // Remove both possible states first
        bbTotal.classList.remove(
          "one-time-purchase-element-active",
          "subscribe-and-save-element-active"
        );

        // Check which label was clicked
        let labelText = label.textContent.trim();
        console.log("Clicked label:", JSON.stringify(labelText));

        if (labelText.includes("One-Time Purchase")) {
          bbTotal.classList.add("one-time-purchase-element-active");
        } else if (labelText.includes("Subscribe & Save")) {
          bbTotal.classList.add("subscribe-and-save-element-active");
        }

        console.log(
          "Updated classes on .bb-added-items-total:",
          bbTotal.classList
        );
      }, 100);

      // Toggle active label UI
      labels.forEach(function (l) {
        l.classList.remove("active-rc-label");
      });
      label.classList.add("active-rc-label");
    });
  });
}
function initializePurchaseLabelListeners() {
  const labels = document.querySelectorAll(".rc-label");

  labels.forEach(function (label) {
    label.addEventListener("click", function () {
      setTimeout(() => {
        let bbTotal = document.querySelector(".bb-added-items-total");

        if (!bbTotal) {
          console.log("Element .bb-added-items-total not found");
          return;
        }

        bbTotal.classList.remove(
          "one-time-purchase-element-active",
          "subscribe-and-save-element-active"
        );

        let labelText = label.textContent.trim();
        console.log("Clicked label:", JSON.stringify(labelText));

        if (labelText.includes("One-Time Purchase")) {
          bbTotal.classList.add("one-time-purchase-element-active");
        } else if (labelText.includes("Subscribe & Save")) {
          bbTotal.classList.add("subscribe-and-save-element-active");
        }

        console.log(
          "Updated classes on .bb-added-items-total:",
          bbTotal.classList
        );
      }, 100);

      labels.forEach(function (l) {
        l.classList.remove("active-rc-label");
      });
      label.classList.add("active-rc-label");
    });
  });
}
function initializeEqualHeightGridItems() {
  function setEqualHeight() {
    var maxHeight = 0;
    $(".create-your-bundle-grid-cell-item").each(function () {
      var thisHeight = $(this).outerHeight();
      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });
    $(".create-your-bundle-grid-cell-item").css("height", maxHeight + "px");
  }

  setEqualHeight();

  $(window).resize(function () {
    $(".create-your-bundle-grid-cell-item").css("height", "");
    setEqualHeight();
  });
}
function initializeMobileBundleToggle() {
  $(document).on("click", ".down-arrow-svg-element", async function () {
    $(this)
      .closest(".bb-added-items-content")
      .toggleClass("active-bb-added-items-container");
    $(".bundle-box-divider-line").toggleClass("active-divider");
    console.log("arrow-clicked");
  });

  $(document).on("click", ".bottom-view-detail-btn", async function (e) {
    e.preventDefault();
    $(".down-arrow-svg-element").trigger("click");
    console.log("bottom-view-detail-btn-clicked");
  });
}
function initializeProductTypeListener() {
  const productTypeRadios = document.querySelectorAll(
    'input[name="prductType"]'
  );
  const customFrequencySelect = document.getElementById("custom-frequency");
  function handleProductTypeChange() {
    const selected = document.querySelector('input[name="prductType"]:checked');
    if (!selected || !customFrequencySelect) return;
    customFrequencySelect.disabled = selected.value === "1";
    updateBundlePrice();
  }
  productTypeRadios.forEach((radio) => {
    radio.addEventListener("change", handleProductTypeChange);
  });
  handleProductTypeChange(); // Initialize on page load
}
function initializeBundleAddToCart() {
  $(document).on(
    "click",
    "a.bb-add-to-cart.bb-add-to-cart-active",
    async function () {
      // Show loader, hide button text
      const loader = document.querySelector(
        ".bb-add-to-cart-wrapper .bb-add-to-cart span.loader"
      );
      const buttonText = document.querySelector(
        ".bb-add-to-cart-wrapper .bb-add-to-cart span.button_text"
      );

      if (loader && buttonText) {
        loader.style.opacity = 1;
        buttonText.style.opacity = 0;
      }

      // Clear Shopify cart
      await fetch(window.Shopify.routes.root + "cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      const selections = [];
      const radioSelector = $('input[type="radio"][name="prductType"]:checked');
      const productType = radioSelector.val();
      const customFrequency = $("#custom-frequency").val();
      const $mainBundleSelector = $("#main_bundle_product");

      // Collect selected bundle items
      $(".bb-item-active").each(function () {
        const variant_id = $(this).data("variant-id");
        const product_id = $(this).data("product-id");
        const selling_plan_id = $(this).data(customFrequency);

        selections.push({
          collectionId: "316751511723",
          externalProductId: product_id,
          externalVariantId: variant_id,
          quantity: 1,
          ...(productType == 2 && { sellingPlan: selling_plan_id }),
        });
      });

      // Prepare main bundle product data
      const bundleProductData = {
        productId: $mainBundleSelector.data("product-id"),
        variantId: $mainBundleSelector.data("variant-id"),
        sellingPlan: $mainBundleSelector.data(customFrequency),
        handle: $mainBundleSelector.data("handle"),
      };

      // Build bundle object
      const bundle = {
        externalVariantId: bundleProductData.variantId,
        externalProductId: bundleProductData.productId,
        selections: selections,
      };

      console.log(bundle);

      // Get bundle cart items from Recharge
      const cartItems = await recharge.bundle.getDynamicBundleItems(
        bundle,
        bundleProductData.handle
      );

      const cartData = { items: cartItems };

      // Add items to cart
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartData),
      });

      // Redirect to checkout
      window.location.href = "/checkout";
    }
  );
}
function initializeBundleQuantityControls() {
  // Handle quantity minus
  $(document).on("click", ".bb-quantity .bb-quantity-minus", function () {
    const $this = $(this);
    const $quantityInput = $this.closest(".bb-quantity").find("input");
    const min = parseInt($quantityInput.attr("min"));
    const quantity = parseInt($quantityInput.val());
    const variantId = $this
      .closest(".bb-free-bag-item")
      .attr("data-variant-id");

    if (quantity > min) {
      $this
        .closest(".bb-quantity")
        .find(".bb-quantity-plus")
        .removeAttr("disable");
    }

    $(`.bb-added-item[data-variant-id="${variantId}"]`).each(function (index) {
      if (index === 0) {
        $(this).find(".remove-bb-item").trigger("click");
      }
    });
  });

  // Handle quantity plus
  $(document).on("click", ".bb-quantity .bb-quantity-plus", function () {
    const $this = $(this);
    const $quantityInput = $this.closest(".bb-quantity").find("input");
    const max = parseInt($quantityInput.attr("max"));
    let quantity = parseInt($quantityInput.val());
    const variantId = parseInt(
      $this.closest("[data-variant-id]").data("variant-id")
    );

    if (quantity >= max) {
      $this.attr("disable", "disable");
    }

    if (quantity < max && getBundleItemQuantity(variantId) < max) {
      quantity += 1;
      $quantityInput.val(quantity).trigger("change");
      $this
        .closest(".bb-free-bag-item")
        .find(".bb-add-product-bundle")
        .trigger("click");
    }
  });

  // Handle manual input change
  $(document).on("change input", ".bb-quantity input", function () {
    const $this = $(this);
    const min = parseInt($this.attr("min"));
    const max = parseInt($this.attr("max"));
    let quantity = parseInt($this.val());
    const variantId = parseInt(
      $this.closest("[data-variant-id]").data("variant-id")
    );

    if (quantity < min && getBundleItemQuantity(variantId) < max) {
      $this.val(min);
    } else if (quantity > max) {
      $this.val(max);
    }
  });
}
function updateBundleProgressUI(count) {
  let discount = "20%",
    threshold = 5;
  if (count < 5) 
  {
    discount = "20%";
    threshold = 5;
  }
  if (count < 4) {
    discount = "15%";
    threshold = 4;
  }
  if (count < 3) {
    discount = "15%";
    threshold = 3;
  }
  if (count < 2) {
    discount = "15%";
    threshold = 2;
  }

  const diff = threshold - count;

    if(count == 1){
      $('.bb-added-item:nth-child(2) .bb-added-item-text').text('Add 1 more and save 10%');
    }else if(count == 2){
      $('.bb-added-item:nth-child(3) .bb-added-item-text').text('Add 1 = free shipping & 20% off');
    }else if(count == 3){
      $('.bb-added-item:nth-child(5) .bb-added-item-text').text('Add 2 more and save 24%');
    }else if(count == 4){
      $('.bb-added-item:nth-child(5) .bb-added-item-text').text('Add 1 more and save 24%');
    }

  const btn = $(".bb-add-to-cart");

  if (count >= 2) {
    btn.find(".button_text").text("Add Bundle to Cart");
    btn.addClass("bb-add-to-cart-active");
  } else {
    btn.find(".button_text").text(`Add ${diff} more`);
    btn.removeClass("bb-add-to-cart-active");
  }
}
function updateCallActionPlaceholders(count) {
  const countDiff = 3 - count;
  const placeholders = [countDiff, countDiff + 1, countDiff + 2];

  $(".bb-item-call-action:not(.bb-item-active) h3").each(function (i) {
    const itemCount = placeholders[i];
    const text = `Add ${itemCount} more ${
      itemCount === 1 ? "Item" : "Items"
    } & save 10%`;
    $(this).html(text);
  });
}
function initializeAddToBundle() {
  $(document).on("click", ".bb-add-product-bundle", function () {
    const $target = $(this).closest(".bb-free-bag-item");
    const variantId = $target.data("variant-id");
    const productId = $target.data("product-id");
    const variantName = $target.data("name");
    const image = $target.data("image");
    const price = $target.data("price");
    const title = $target.find("h2").html();
    const priceFormat = $target.data("price-format");
    const twentyFourDays = $target.data("60-days");
    const fortyEightDays = $target.data("120-days");
    const ninetySixDays = $target.data("240-days");
    const maxAllowed = parseInt($target.data("max"));
    const currentQty = getBundleItemQuantity(variantId);
    subscriptionInput(); 
    if (currentQty >= maxAllowed) return;

    $target.addClass("bb-added-to-bundle");

    const $placeholder = $(
      ".bb-added-item.bb-item-active + .bb-item-placeholder"
    ).length
      ? $(".bb-added-item.bb-item-active + .bb-item-placeholder")
      : $(".bb-added-items-container > .bb-item-placeholder:first-child");

    $placeholder.find(".bb-added-item-image").html("");

    const itemHTML = `
      <a href="javascript:void(0)" class="remove-bb-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="9.02" height="9.02" viewBox="0 0 9.02 9.02">
          <g transform="translate(0.354 0.353)">
            <path d="M-3487.372-4476.921l-8.312-8.313" transform="translate(3495.685 4485.234)" fill="none" stroke="#fff" stroke-width="1"/>
            <path d="M8.312,8.313,0,0" transform="translate(8.313 0) rotate(90)" fill="none" stroke="#fff" stroke-width="1"/>
          </g>
        </svg>
      </a>
      <img src="${image}" alt="" />
    `;

    $placeholder
      .attr({
        "data-variant-id": variantId,
        "data-name": variantName,
        "data-product-id": productId,
        "data-60-days": twentyFourDays,
        "data-120-days": fortyEightDays,
        "data-240-days": ninetySixDays,
        "data-image": image,
      })
      .removeClass("bb-item-placeholder")
      .addClass("bb-item-active");

    $placeholder.find(".bb-added-item-title").html(variantName);
    $placeholder.find(".bb-added-item-image").html(itemHTML);

    // Update count, price, UI
    const oldTotal = $(".bb-added-items-total").data("price");
    $(".bb-added-items-total").data("price", oldTotal + price);

    const oldCount = parseInt($("#total_bundle_products").val());
    const newCount = oldCount + 1;
    $("#total_bundle_products").val(newCount);

    updateBundleProgressUI(newCount);
    updateCallActionPlaceholders(newCount);

    $(".recharge-subscriptions-new-style").toggle(newCount >= 1);

    saveToBundleMetadata(variantId, 1);
    updateBundlePrice();
  });
}
function initializeRemoveFromBundle() {
  $(document).on("click", ".remove-bb-item", function () {
    const $target = $(this).closest(".bb-item-active");
    const variantId = $target.data("variant-id");
    const count = $(".bb-item-active").length;

    $target.remove();

    // Add placeholder back
    const placeholderHTML = `
      <div class="each-row bb-added-item bb-item-placeholder bb-item-call-action">
        <div class="bb-added-item-inner">
          <div class="bb-added-item-image">
            <img src="https://cdn.shopify.com/s/files/1/0245/5296/4170/files/Vector_22.svg?v=1742185319" alt="placeholder-bottle-image">
          </div>
          <div class="bb-added-item-title"></div>
          <div class="bb-added-item-text">&nbsp;</div>
        </div>
      </div>`;
    $(".bb-added-items-container").append(placeholderHTML);

    // Update placeholder text
    $(".bb-added-items-container .bb-added-item").each(function (index) {
      const text = $(this).find(".bb-added-item-text");
      const textMap = [
        "",
        "Add 2, get 10% off",
        "Add 3, get 20% off + free shipping!",
        "",
        "Add 5, get 24% off",
      ];
      text.text(textMap[index] || "");

      if (text.text().trim() === "") {
        $(this).addClass("hide-bb-added-item-without-text-element");
      } else {
        $(this).removeClass("hide-bb-added-item-without-text-element");
      }
    });

    // Update total count
    const oldCount = parseInt($("#total_bundle_products").val());
    const newCount = oldCount - 1;
    $("#total_bundle_products").val(newCount);

    updateBundleProgressUI(newCount);
    updateCallActionPlaceholders(newCount);

    // Update product quantity
    const $qtyInput = $(
      `.bb-free-bag-item[data-variant-id="${variantId}"] .bb-quantity input`
    );
    let qty = parseInt($qtyInput.val());
    if (qty > 1) {
      $qtyInput.val(qty - 1);
    } else {
      $(`.bb-free-bag-item[data-variant-id="${variantId}"]`).removeClass(
        "bb-added-to-bundle"
      );
    }

    $(".recharge-subscriptions-new-style").toggle(newCount >= 1);
    $(".shipping-price-element").toggle(newCount >= 2);

    saveToBundleMetadata(variantId, -1);
    updateBundlePrice();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeBundleQuantityControls();
  initializeAddToBundle();
  initializeRemoveFromBundle();
  initSubscriptionToggle();
  initializeProductPopupsAndAccordion();
  initializeBundleAddToCart();
  initializeProductTypeListener();
  initializeEqualHeightGridItems();
  initializePurchaseLabelListeners();
  initializeMobileBundleToggle();
});
$(document).on("shopify:section:load", function (event) {
  initializeBundleQuantityControls();
  initializeAddToBundle();
  initializeRemoveFromBundle();
  initSubscriptionToggle();
  initializeProductPopupsAndAccordion();
  initializeBundleAddToCart();
  initializeProductTypeListener();
  initializeEqualHeightGridItems();
  initializePurchaseLabelListeners();
  initializeMobileBundleToggle();
});


function subscriptionInput() {
let checkedInput = document.querySelector('.subscribe_label_wrapper input[name="prductType"]:checked');
  if (checkedInput) {
    console.log("Checked input value:", checkedInput.value);
    console.log("Checked input ID:", checkedInput.id);
      if (checkedInput.value === "2" && checkedInput.id === "atc_subscription") {
        $(".bb-added-items-total").addClass("subscribe-and-save-element-active");
      }
  } else {
    console.log("No radio input is checked on load.");
  }
}
document.addEventListener("DOMContentLoaded", subscriptionInput);